import script from "./shoplist.vue?vue&type=script&setup=true&lang=js"
export * from "./shoplist.vue?vue&type=script&setup=true&lang=js"

import "./shoplist.vue?vue&type=style&index=0&id=2e0ca8b2&lang=less&scoped=true"

import exportComponent from "/usr/share/nginx/html/vue_saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e0ca8b2"]])

export default __exports__